<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <PoiForm @submit-requested="submitRequested" :poiType="this.$route.query.type"></PoiForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import PoiForm from './PoiForm.vue'

  export default {
  components: { PoiForm },
  methods: {
    ...mapActions('pois', ['postPoi']),
    submitRequested (input) {
      this.postPoi(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 